module.exports = __webpack_public_path__ + "assets/img/logo-marcas.svg";